import { render, staticRenderFns } from "./storages.vue?vue&type=template&id=535f2671&"
import script from "./storages.vue?vue&type=script&lang=js&"
export * from "./storages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports